import { FEATURE_NAME } from 'src/redesign/features/EventsFilters/constants';
import { createSlice } from '@reduxjs/toolkit';
import { EventsFiltersState } from 'src/redesign/features/EventsFilters/types';
import * as actions from './actions';

const initialState: EventsFiltersState = {
  eventAttendeesFilterValues: null,
  filtersData: null,
  error: null,
  loading: false,
};

const CLEAR_FILTERS_DATA = {
  attendee_order: '',
  selected_attendee_status: '',
  selected_attendee_email: '',
  selected_attendee: '',
  selected_ticket_uuid: '',
  selected_event_ids: '',
  show_waitlist_subscribers: '',
  show_unsent_emails: '',
  is_filtered: false,
  offset: '0',
  limit: '10',
};
export const eventsFiltersSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setFiltersData: (state, action) => {
      state.filtersData = { ...state.filtersData, ...action.payload };
    },
    cleatFiltersData: (state) => {
      state.filtersData = CLEAR_FILTERS_DATA;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actions.fetchEventAttendeesFilterValues.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.eventAttendeesFilterValues = action.payload.data;
      let selectedEventsIds: string;
      if (action.payload.data.occurrences.length > 0) {
        selectedEventsIds = action.payload.data.occurrences.map((item) => item.id).join(',');
      }

      const newData = {
        ...CLEAR_FILTERS_DATA,
        selected_event_ids: selectedEventsIds,
      };
      state.filtersData = newData;
    });
    builder.addCase(actions.fetchEventAttendeesFilterValues.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(actions.fetchEventAttendeesFilterValues.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
  },
});

export const setFiltersDataAction = eventsFiltersSlice.actions.setFiltersData;
export const clearFiltersDataAction = eventsFiltersSlice.actions.cleatFiltersData;
